<template>
  <LinkWithIcon
    text="Nitrex Support"
    icon="pi pi-envelope"
    :on-click="mailTo"
  />
</template>

<script setup lang="ts">
import {
  computed,
} from 'vue';

import LinkWithIcon from '../link-with-icon/link-with-icon.vue';

const props = defineProps<{
  subject?: string,
  body?: string,
}>();

const mailTo = computed<string>(() => {
  const link = [
    'mailto:support@qmulus.ai',
  ];

  const params = [];
  if (props.subject) {
    params.push(`subject=${encodeURIComponent(props.subject)}`);
  }
  if (props.body) {
    params.push(`body=${encodeURIComponent(props.body)}`);
  }
  if (params.length) {
    link.push(params.join('&'));
  }

  return link.join('?');
});
</script>
